import styled, { css } from 'styled-components';
import { mobileCss } from '../../styling';

export const FlexGrowCss = css`
  flex:1;
`;
export const FlexGrow = styled.div`
  ${FlexGrowCss}
`;

export const FlexCss = css`
  display: flex;
`;

export const Flex = styled.div`
  ${FlexCss}
`;

export const MobileFlexCss = css`
  ${FlexCss}
  ${mobileCss`
    flex-direction: column;
  `}
`;

export const MobileFlex = styled.div`
  ${MobileFlexCss}
`;

export const FlexColumnCss = css`
  flex-direction: column;
`;

export const FlexColumn = styled(Flex)`
  ${FlexColumnCss}
`;

export const CenterFlex = styled(Flex)`
  width:100%;
  height:100%;
  align-items:center;
  justify-content:center;
`;
